import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ActionConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = "Confirmar",
  confirmColor = "#d9534f",
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle
        sx={{
          backgroundColor: confirmColor,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontFamily: "Montserrat-Bold",
          fontSize: "1rem",
          px: 3,
          py: 2,
        }}
      >
        {title}
        <IconButton onClick={onClose} sx={{ color: "#fff" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 3, mt: 1 }}>
        <Typography
          sx={{
            fontFamily: "Montserrat-Regular",
            fontSize: "0.95rem",
            color: "#334155",
            lineHeight: 1.55,
          }}
        >
          {description}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, pt: 1, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" sx={btnStyles}>
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            ...btnStyles,
            backgroundColor: confirmColor,
            "&:hover": { backgroundColor: confirmColor, filter: "brightness(0.92)" },
          }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const btnStyles = {
  textTransform: "none",
  fontFamily: "Montserrat-Medium",
  borderRadius: "8px",
  px: 2.5,
  boxShadow: "none",
};

export default ActionConfirmDialog;
